import React from 'react';
import { useHistory } from 'react-router';
import { SignInFormHeader } from 'components/SignInFormHeader';
import { LoginContainer } from '../../Common/Controls/LoginContainer';
import { SignupForm } from '../SignupForm';

type IProps = {
    handleSignup: (payload: any) => void;
}

export const SignupView: React.FC<IProps> = (props: IProps) => {
    const history = useHistory();
    return (
        <LoginContainer>
            <SignInFormHeader background="#315CD5" color="white" handleClick={() => { history.push('/login')}} />
            <SignupForm {...props}></SignupForm>
        </LoginContainer>
    );
};
